// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .popup-content {
  padding: 25px;
}
:host div div.modal-content {
  padding-top: 25px;
  padding-bottom: 25px;
  width: 80%;
  position: absolute;
  top: 20%;
  left: 10%;
  border-radius: 15px !important;
  background-color: #262626;
  font-style: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
:host div div.modal-content ion-icon {
  height: 25px;
  width: 25px;
  color: white;
  position: absolute;
  right: 5%;
  top: 5%;
}
:host div div.modal-content .title {
  font-weight: 600;
  font-size: 20px;
  line-height: 22px;
  color: #FFFFFF;
}
:host div div.modal-content .article {
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgb(197, 197, 190);
  margin-left: 8%;
  margin-right: 8%;
  text-align: center;
}
:host div div.modal-content .duration {
  width: 100%;
  padding: 10px;
  background: rgba(217, 217, 217, 0.2);
  text-align: center;
}
:host div div.modal-content .duration > .duration-title {
  font-weight: 400;
  font-size: 13px;
  line-height: 17px;
  margin: 0;
}
:host div div.modal-content .duration > .duration-value {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin: 0;
}
:host div div.modal-content ion-button {
  width: 80%;
  height: 45px;
  --background: #363636;
  --border-radius: 35px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/dispute-confirmation-popup/dispute-confirmation-popup.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAII;EACE,iBAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AAFN;AAIM;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AAFR;AAKM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHR;AAMM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAJR;AAOM;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;AALR;AAOQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AALV;AAQQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AANV;AAUM;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;AARR","sourcesContent":[":host {\n  .popup-content {\n    padding: 25px;\n  }\n\n  div {\n    div.modal-content {\n      padding-top:25px;\n      padding-bottom:25px;\n      width: 80%;\n      position: absolute;\n      top: 20%;\n      left: 10%;\n      border-radius: 15px !important;\n      background-color: #262626;\n      font-style: normal;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-around;\n\n      ion-icon {\n        height: 25px;\n        width: 25px;\n        color: white;\n        position: absolute;\n        right: 5%;\n        top: 5%;\n      }\n\n      .title {\n        font-weight: 600;\n        font-size: 20px;\n        line-height: 22px;\n        color: #FFFFFF;\n      }\n\n      .article {\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 18px;\n        color: rgba(197, 197, 190, 1);\n        margin-left: 8%;\n        margin-right: 8%;\n        text-align: center;\n      }\n\n      .duration {\n        width: 100%;\n        padding: 10px;\n        background: rgba(217, 217, 217, 0.2);\n        text-align: center;\n\n        & > .duration-title{\n          font-weight: 400;\n          font-size: 13px;\n          line-height: 17px;\n          margin: 0;\n        }\n\n        & > .duration-value{\n          font-weight: 600;\n          font-size: 20px;\n          line-height: 24px;\n          margin: 0;\n        }\n      }\n\n      ion-button {\n        width: 80%;\n        height: 45px;\n        --background: #363636;\n        --border-radius: 35px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
